{
  "common": {
    "appName": "TURBINA",
    "or": "o",
    "back": "Volver",
    "cancel": "Cancelar",
    "ok": "OK",
    "onboardingIncompleteTitle": "Onboarding incompleto",
    "onboardingIncompleteMessage": "Tu onboarding está incompleto y puedes editarlo en la configuración de usuario.",
    "turbinaLogo": "Logotipo de Turbina",
    "airplaneProgressIndicator": "Indicador de progreso del avión",
    "currencyAudNotice": "Todos los montos están en dólares australianos (AUD)."
  },
  "index": {
    "title": "Haz realidad tu experiencia en el extranjero",
    "subtitle": "Planifica tu viaje, junta el dinero y recibe apoyo de tu comunidad.",
    "cta": "Empezar mi viaje",
    "secondaryText": "Es gratis. Avanza a tu ritmo.",
    "pageTitle": "Turbina - La Plataforma para Tu Aventura Global",
    "pageDescription": "Turbina ayuda a jóvenes de América Latina a planificar, ahorrar y hacer realidad su Working Holiday o experiencia de estudios en el exterior.",
    "heroBadge": "Para aventureros latinos",
    "statsGoal": "Planifica tu viaje",
    "statsDate": "Recauda fondos",
    "statsInvolved": "Recibe apoyo",
    "pilotCohort": "Generación 1"
  },
  "publicHeader": {
    "whatWeDo": "QUÉ HACEMOS",
    "aboutUs": "NOSOTROS",
    "help": "AYUDA",
    "login": "INGRESAR",
    "signUp": "REGÍSTRATE"
  },
  "auth": {
    "pageTitle": "Turbina - Iniciar sesión",
    "callToAction": "¡ES HORA DE QUE TE AUTENTIQUES!",
    "welcome": "¡Bienvenido! Por favor ingresa para continuar.",
    "chooseMethod": "Elige un método para acceder rápidamente a tu cuenta.",
    "continueGoogle": "Continuar con Google",
    "continueApple": "Continuar con Apple (próximamente)",
    "continueFacebook": "Continuar con Facebook (próximamente)",
    "googleRedirecting": "Conectando con Google...",
    "googleUnavailable": "El acceso con Google no está disponible en este momento.",
    "googleErrorFallback": "No pudimos iniciar sesión con Google. Inténtalo de nuevo.",
    "noAccountFound": "No se encontró una cuenta con esta cuenta de Google. Regístrate primero.",
    "googleCallbackTitle": "Acceso con Google",
    "googleCallbackLoading": "Estamos terminando tu acceso con Google...",
    "googleCallbackLoadingHint": "Estamos conectando tu cuenta de Turbina de forma segura.",
    "googleCallbackError": "No pudimos completar tu acceso con Google. Inténtalo de nuevo.",
    "googleCancelled": "Cancelaste el acceso con Google.",
    "tryAnotherMethod": "Probar otro método",
    "signInWithEmail": "Iniciar sesión con email",
    "continueEmail": "Continuar con email",
    "termsNotice": "Al continuar, aceptas nuestros",
    "termsOfService": "Términos de Servicio",
    "and": "y",
    "privacyPolicy": "Política de Privacidad."
  },
  "emailAuth": {
    "pageTitle": "Turbina - Iniciar sesión",
    "pageDescription": "Accede a Turbina para continuar tu planificación internacional, revisar tu hoja de ruta, avanzar tu postulación y gestionar tu cuenta de forma segura.",
    "titleSignIn": "Iniciar sesión en Turbina",
    "titleSignUp": "Crear tu cuenta",
    "titleConfirm": "Confirma tu email",
    "emailPlaceholder": "Email",
    "passwordPlaceholder": "Contraseña",
    "confirmationHint": "Enviamos un código de confirmación a {{email}}. Ingrésalo abajo.",
    "checkJunkFolder": "Por favor revisa tu carpeta de spam o correo no deseado si no ves el correo.",
    "codePlaceholder": "123456",
    "confirmationCodeRequired": "El campo no puede estar vacío.",
    "confirmationCodeInvalid": "Código incorrecto.",
    "buttonSignIn": "Iniciar sesión",
    "buttonSignUp": "Crear cuenta",
    "buttonConfirm": "Confirmar e iniciar sesión",
    "namePlaceholder": "Nombre",
    "surnamePlaceholder": "Apellido",
    "phonePlaceholder": "Teléfono (con código de país)",
    "passwordHint": "Tu contraseña debe tener al menos 8 caracteres y contener un número.",
    "privacyNotice": "Al crear tu cuenta confirmas que:",
    "consentText": "Al hacer clic en \"Crear cuenta\" confirmas",
    "privacyText": "Has leído y aceptas el Aviso de Recopilación de Privacidad (que describe cómo Turbina maneja tu información personal) y los Términos y Condiciones de la Aplicación.",
    "acceptTermsPrefix": "He leído y acepto los",
    "acceptTermsLink": "Términos de Uso",
    "acceptPrivacyPrefix": "Acepto la",
    "acceptPrivacyLink": "Política de Privacidad",
    "consentRequiredError": "Debes aceptar los Términos de Uso y la Política de Privacidad para crear una cuenta.",
    "switchToSignUp": "¿No tienes cuenta? Regístrate",
    "switchToSignIn": "¿Ya tienes cuenta? Inicia sesión",
    "passwordMismatch": "La contraseña no coincide con la que usaste durante el registro.",
    "errorFallback": "Algo salió mal. Por favor intenta de nuevo.",
    "requiredPassword": "La contraseña es obligatoria.",
    "requiredName": "El nombre es obligatorio.",
    "requiredSurname": "El apellido es obligatorio.",
    "invalidPhone": "Ingresa un teléfono válido en formato internacional (por ejemplo +56999999999).",
    "requiredPhone": "El número de teléfono es obligatorio. Ingrésalo en formato internacional (por ejemplo +56999999999).",
    "titleForgot": "Restablecer tu contraseña",
    "titleReset": "Establecer nueva contraseña",
    "buttonForgotSend": "Enviar código de restablecimiento",
    "buttonReset": "Establecer nueva contraseña",
    "newPasswordPlaceholder": "Nueva contraseña",
    "forgotPasswordLink": "¿Olvidaste tu contraseña?",
    "resendCode": "Reenviar código",
    "resendCodeSuccess": "¡Código enviado!",
    "resetCodePlaceholder": "Código de restablecimiento",
    "forgotPasswordHint": "Te enviaremos un código de restablecimiento a tu email.",
    "heroHeadline": "Viaja más lejos.\nPlanea mejor.",
    "heroAccent": "Ve juntos.",
    "heroSubtitle": "Únete a un grupo de viajeros, crea un plan de ahorro y haz realidad tu próxima aventura.",
    "feature1Title": "Viajes en grupo",
    "feature1Sub": "Crea y únete a un grupo de viajeros como tú",
    "feature2Title": "Ahorro inteligente",
    "feature2Sub": "Metas automáticas que mantienen tu viaje en curso",
    "feature3Title": "Comunidad real",
    "feature3Sub": "Conéctate, comparte e inspírate mutuamente",
    "socialProof": "La favorita de quienes planean su próxima gran aventura",
    "webSignInSub": "Bienvenido de vuelta. Tu viaje continúa aquí.",
    "webSignUpSub": "Tu aventura empieza con una cuenta.",
    "unableToCheckAvailability": "No se pudo verificar la disponibilidad. Por favor intenta de nuevo.",
    "signInError": "La contraseña no coincide con la cuenta de usuario o la cuenta no existe. Verifica el nombre de usuario y la contraseña e intenta de nuevo.",
    "resendError": "No se pudo enviar el código de confirmación. Por favor intenta de nuevo.",
    "genericError": "Algo salió mal. Por favor intenta de nuevo."
  },
  "onboarding": {
    "pageTitle": "Turbina - Onboarding",
    "question": "¿Qué te trae a Australia?",
    "helpText": "Elige la opción que mejor describe tu objetivo",
    "studyEnglish": "Aprender inglés",
    "study_english": "Aprender inglés",
    "studyEnglishSub": "Mejora tu fluidez en un entorno inmersivo",
    "study": "Estudiar",
    "studySub": "Inscribirte en un programa o curso",
    "work": "Trabajar",
    "workSub": "Ganar experiencia laboral internacional",
    "experience": "Vive el sueño australiano",
    "experienceSub": "Una experiencia de vida internacional completa",
    "notSure": "Aún no lo sé",
    "not_sure": "Aún no lo sé",
    "notSureSub": "Explora tus opciones y decide después"
  },
  "onboardingDestination": {
    "pageTitle": "Turbina - Onboarding — Destino",
    "question": "¿A qué ciudad de Australia te gustaría ir?",
    "helpText": "Estas son las ciudades donde Turbina puede ayudarte mejor.",
    "brisbane": "Brisbane",
    "sydney": "Sydney",
    "melbourne": "Melbourne",
    "perth": "Perth",
    "adelaide": "Adelaide",
    "regional": "Algún pueblo",
    "anotherCountry": "Otro país",
    "notSure": "Aún no lo sé",
    "another_country": "Otro país",
    "not_sure": "Aún no lo sé"
  },
  "onboardingTimeline": {
    "pageTitle": "Turbina - Onboarding — Tiempo",
    "question": "¿Cuándo te vas?",
    "helpText": "¿Qué tan listo estás?",
    "confirmCta": "Definir mi pista →",
    "ready_to_go": "Listo para partir",
    "almost_ready": "Casi listo",
    "still_planning": "Todavía planificando",
    "just_exploring": "Solo explorando",
    "4to6": "4–6 meses",
    "6to8": "6–8 meses",
    "8to12": "8–12 meses",
    "12to18": "12–18 meses"
  },
  "onboardingOrigin": {
    "pageTitle": "Turbina - Onboarding — Origen",
    "question": "¿Desde qué ciudad y país iniciarías tu viaje?",
    "cityPlaceholder": "Ciudad de origen",
    "cityFocusHint": "Empieza aquí: escribe tu ciudad para continuar.",
    "countryPlaceholder": "Selecciona tu país",
    "countryLabel": "País de origen",
    "continue": "Continuar",
    "back": "Volver"
  },
  "onboardingAge": {
    "pageTitle": "Turbina - Onboarding — Edad",
    "question": "¿Cuántos años tienes?",
    "under18": "Menos de 18",
    "18to24": "18–24",
    "25to34": "25–34",
    "35to44": "35–44",
    "45to54": "45–54",
    "55to64": "55–64",
    "65plus": "65+"
  },
  "onboardingSavings": {
    "pageTitle": "Turbina - Onboarding — Finanzas",
    "question": "¿Tienes dinero o ahorros para pagar este proyecto?",
    "gaugeLabel": "¿Cómo está tu tanque de combustible?",
    "gaugeSubtext": "Sé honesto/a — Turbina funciona para todas las situaciones",
    "gaugeEmpty": "Vacío",
    "gaugeSomeSavings": "Algo de ahorro",
    "gaugeFull": "Lleno ✈",
    "noProblem": "Tanque lleno",
    "noProblemSub": "El dinero no es el obstáculo",
    "someSavings": "Construyendo momentum",
    "someSavingsSub": "Tengo algo de ahorros guardados",
    "noSavings": "Empezando de cero",
    "noSavingsSub": "Sin ahorros aún — y está bien"
  },
  "onboardingSituation": {
    "pageTitle": "Turbina - Onboarding — Situación",
    "question": "¿Qué opción describe mejor tu situación actual?",
    "highSchool": "Graduado de secundaria",
    "high_school": "Graduado de secundaria",
    "university": "Graduado de universidad",
    "working": "Trabajando",
    "student": "Estudiante",
    "other": "Otro"
  },
  "onboardingSummary": {
    "pageTitle": "Turbina - Onboarding — Resumen",
    "title": "Este podría ser tu viaje",
    "destination": "Destino",
    "estimatedTime": "Tiempo estimado",
    "goal": "Objetivo",
    "origin": "Ciudad de origen",
    "motivational": "No es solo un sueño.\nEs un proyecto que puedes construir paso a paso.",
    "createProject": "Crear mi proyecto →",
    "back": "Volver",
    "boardingPassTitle": "PASE DE ABORDAJE TURBINA",
    "from": "DESDE",
    "to": "HACIA",
    "goal_label": "OBJETIVO",
    "timeline_label": "TIEMPO",
    "passenger": "PASAJERO",
    "explorer": "Explorador",
    "mapOfDestination": "Mapa de {{destination}}",
    "mapOfSelectedDestination": "Mapa del destino seleccionado"
  },
  "onboardingVideo": {
    "pageTitle": "Turbina - Onboarding — Video",
    "headline": "Una última cosa antes de despegar",
    "subtext": "Mira este corto video de nuestro equipo",
    "watchFirst": "Pero primero, necesitas ver esto",
    "question": "¿Estás dispuesto/a a unirte al programa?",
    "notInterested": "No me interesa",
    "joinWaitlist": "Unirme a lista de espera →",
    "letsDoIt": "Estoy adentro — vamos →"
  },
  "onboardingWaitlist": {
    "pageTitle": "Turbina - Lista de espera",
    "question": "Únete a la lista de espera",
    "subtitle": "Te avisaremos en cuanto se abra un cupo.",
    "emailPlaceholder": "Tu correo electrónico",
    "submit": "Unirme a la lista",
    "invalidEmail": "Por favor ingresa un correo electrónico válido.",
    "successTitle": "¡Estás en la lista!",
    "successMessage": "Te contactaremos en cuanto abramos nuevos cupos. Mantente atento/a.",
    "instagramCta": "Mientras tanto, visita nuestra página de Instagram para saber más",
    "backToHome": "Volver al inicio",
    "errorFallback": "Algo salió mal. Por favor intenta de nuevo."
  },
  "apply": {
    "pageTitle": "Turbina - Postulación",
    "title": "Postula a la Generación 1 de Turbina",
    "instructions": "Elige una forma de postular.",
    "pathTitle": "Selecciona tu camino de postulación",
    "videoOptionTitle": "Enviar video",
    "videoOptionSubtitle": "Cuéntanos tu historia en máximo 1 minuto.",
    "writtenOptionTitle": "Responder preguntas por escrito",
    "writtenOptionSubtitle": "Usa esta opción solo si decides no enviar video.",
    "highlyRecommended": "Altamente recomendado",
    "videoPreferredMessage": "Las postulaciones con video tendrán prioridad durante nuestro proceso de selección.",
    "prompt1": "¿Por qué quieres hacer este viaje?",
    "prompt2": "¿Qué es lo que más te limita a lograr este objetivo?",
    "prompt3": "¿Qué quieres lograr al final de esta experiencia?",
    "prompt4": "¿Por qué crees que deberías ser parte de la Generación 1 de Turbina?",
    "videoUrlPlaceholder": "Link de tu video",
    "videoUrlHelper": "Sube tu video a YouTube en modo no listado y luego copia y pega el enlace aquí. No listado significa que solo las personas con el enlace pueden verlo.",
    "invalidVideoUrl": "Por favor ingresa una URL válida (ej. https://youtube.com/...)",
    "pathRequired": "Selecciona una opción para continuar.",
    "writtenHelper": "Responde las cuatro preguntas. Cada respuesta debe tener al menos 50 caracteres.",
    "writtenAnswerPlaceholder": "Escribe tu respuesta",
    "writtenAnswersRequired": "Debes completar todas las respuestas escritas.",
    "writtenAnswerTooShort": "Cada respuesta debe tener al menos {{min}} caracteres.",
    "characterCounter": "{{current}} / {{max}}",
    "submit": "Postula ahora",
    "skip": "Saltar",
    "confirmationTitle": "Tu postulación ha sido enviada",
    "confirmationText": "Te contactaremos en pocos días para confirmar tu participación.",
    "confirmationTitleVideo": "Tu postulación en video fue enviada",
    "confirmationTextVideo": "Revisaremos tu postulación y te contactaremos pronto.",
    "confirmationTitleWritten": "Tu postulación escrita fue enviada",
    "confirmationTextWritten": "Revisaremos tus respuestas después de las postulaciones con video y te contactaremos en pocos días.",
    "errorFallback": "No se pudo enviar tu postulación. Por favor intenta de nuevo.",
    "editApplication": "Editar mi postulación",
    "instagramCta": "Mientras tanto, visita nuestra página de Instagram para saber más",
    "backToHome": "Volver al inicio"
  },
  "about": {
    "pageTitle": "Turbina - Sobre nosotros",
    "pageDescription": "Conoce cómo Turbina ayuda a exploradores latinoamericanos a planificar experiencias internacionales con hojas de ruta personalizadas.",
    "whoWeAreTitle": "Otros Meridianos",
    "whoWeAreDesc": "Somos el equipo detrás de Turbina. Síguenos en redes sociales:",
    "hero": "Ayudamos a aventureros a irse al exterior. En serio.",
    "heroSub": "Turbina es una plataforma para aventureros — especialmente de América Latina — que sueñan con una experiencia internacional pero no saben por dónde empezar, les falta dinero, y no tienen apoyo de una comunidad. Turbina convierte ese sueño en un proyecto estructurado y alcanzable.",
    "freeForUsers": "GRATIS PARA USUARIOS.",
    "freeMission": "Turbina es completamente gratuita para los viajeros. Nuestra misión es hacer que las experiencias internacionales transformadoras sean accesibles para todos.",
    "planJourneyTitle": "Planifica tu viaje",
    "planJourneyDesc": "Te ayudamos a crear una hoja de ruta clara alineada con tus objetivos, presupuesto y país de origen — para que siempre sepas cuál es el siguiente paso.",
    "financeTripTitle": "Financia tu viaje",
    "financeTripDesc": "Comparte tu proyecto con familia y amigos para recaudar fondos. Ofrece servicios como clases particulares o cuidado de niños y sigue cada contribución hacia tu meta.",
    "buildCommunityTitle": "Construye tu comunidad",
    "buildCommunityDesc": "Conéctate con antelación con otros viajeros que van a la misma ciudad al mismo tiempo. Nunca estás solo/a en este viaje.",
    "trackProgressTitle": "Sigue tu progreso",
    "trackProgressDesc": "Mira cómo tu avión se acerca a tu destino a medida que ahorras. Los hitos qué te mantienen motivado/a desde el primer día.",
    "roadmapTitle": "Hoja de Ruta Personalizada",
    "roadmapDesc": "Cuando te unes a Turbina, aprendemos sobre tus objetivos: adónde quieres ir, qué tipo de experiencia (trabajo, estudio, idioma), cuánto tiempo y tu situación financiera. A partir de eso, construimos una hoja de ruta personalizada con opciones de visa, estimaciones de costos, plazos y pasos de preparación.",
    "savingsTitle": "Sistema de Ahorro",
    "savingsDesc": "Sigue tu progreso de ahorro visualmente con hitos. Crea una página de campaña personal donde amigos y familiares puedan apoyar tu viaje con contribuciones. La plataforma también puede permitirte ofrecer servicios a tu comunidad para acelerar tus ahorros.",
    "communityTitle": "Comunidad y Conexión",
    "communityDesc": "Conéctate con otros que persiguen experiencias similares. Turbina te une con personas que planean viajar al mismo destino o en el mismo período de tiempo, creando comunidades de viajeros que se apoyan mutuamente durante el proceso de preparación.",
    "demoTitle": "Demo",
    "demoDesc": "Un recorrido rápido por la experiencia Turbina, desde la planificación hasta el apoyo de la comunidad.",
    "watchOnYouTube": "Ver en YouTube",
    "freeTitle": "Gratis.",
    "freeDesc": "Turbina es completamente gratuita para los viajeros. Nuestra misión es hacer que las experiencias internacionales sean accesibles para todos. Generamos valor para las industrias que se benefician de la movilidad internacional — aerolíneas, bancos, escuelas de idiomas, universidades, aseguradoras — que pueden llegar a nuestros usuarios a través de un marketplace basado en datos."
  },
  "dashboard": {
    "pageTitle": "Turbina - Panel",
    "greeting": "Hola, {{name}}. Tu aventura en Australia",
    "fallbackUserName": "Explorador",
    "plan": "Aquí está tu plan de Working Holiday Australia.",
    "plan_with_context": "Tu plan {{goal}} — {{timeline}}",
    "defaultDestination": "Brisbane, Australia",
    "destinationBadge": "Destino",
    "runwayProgress": "Progreso de pista",
    "progressToggle": "Progreso",
    "repeatToggle": "Repetir",
    "ofYourGoal": "de tu meta",
    "edit": "Editar",
    "daysLeft": "{{days}} días restantes",
    "departureDate": "Fecha de salida",
    "done": "Listo",
    "flightFund": "Fondo de Vuelo",
    "initialExpenses": "Gastos Iniciales",
    "emergency": "Emergencia",
    "savingsGoalLabel": "Ahorros",
    "progressLabel": "Progreso:",
    "savings": "Ahorros",
    "goal": "Meta",
    "departure": "Salida",
    "savingsTotal": "Ahorros",
    "remaining": "Restante",
    "mapLoading": "Cargando mapa...",
    "mapProgressPromptTitle": "¿Quieres ver tu progreso en el mapa?",
    "mapProgressPromptMessage": "Acabas de agregar ahorros. ¿Quieres activar ahora la vista de progreso en el mapa?",
    "mapProgressPromptDecline": "Ahora no",
    "mapProgressPromptAccept": "Sí, mostrar progreso",
    "walletPreviewTag": "Vista previa de billetera",
    "walletPreviewTitle": "Billetera digital",
    "walletPreviewDescription": "Muy pronto podrás conectar tu billetera y automatizar tus ahorros de viaje desde un único lugar seguro.",
    "walletPreviewButton": "Acceso anticipado"
  },
  "savingsCard": {
    "accountConnected": "Cuenta conectada",
    "deposit": "+ Depositar",
    "convert": "Convertir",
    "totalGoal": "Meta Total Australia",
    "remaining": "Restante"
  },
  "miniCard": {
    "ofGoal": "de ${{goal}} meta"
  },
  "header": {
    "myPlan": "Mi Plan",
    "savings": "Ahorros",
    "community": "Comunidad",
    "campaign": "Campaña",
    "hq": "HQ",
    "notifications": "Notificaciones",
    "resources": "Recursos",
    "openMenu": "Abrir menú",
    "closeMenu": "Cerrar menú",
    "goHome": "Ir al inicio",
    "editProfile": "Editar perfil",
    "navigate": "Navegar"
  },
  "campaign": {
    "pageTitle": "Turbina - Campaña",
    "publicFallbackTitle": "Campaña",
    "generatedTitleByName": "Campaña de {{name}}",
    "publicNotFoundTitle": "Campaña no encontrada",
    "publicNotFoundBody": "Es posible que esta campaña no exista todavía o no se haya publicado.",
    "breadcrumbHome": "Inicio",
    "breadcrumbMyCampaign": "Mi Campaña",
    "editStory": "Editar",
    "seePublicCampaign": "Ver campaña pública",
    "publishNow": "Publicar campaña ahora",
    "myStory": "Mi Historia",
    "aboutThisCampaign": "Sobre esta campaña",
    "supportThisCampaign": "Apoya esta campaña",
    "servicesOffered": "Servicios ofrecidos",
    "visibleToPublic": "Visible al público",
    "storyLine1": "Hola a todos! Soy Camila, y tengo un sueño: vivir y trabajar en Australia por un año.",
    "storyLine2": "Como muchos saben, siempre he querido explorar Oceanía. Después de ahorrar durante dos años, estoy a un paso de lograr la visa Working Holiday. Sin embargo, los costos iniciales (pasajes, seguro médico y el \"show money\" requerido por el gobierno) son un desafío grande.",
    "storyLine3": "Cualquier aporte, por pequeño que sea, me ayuda a estar más cerca de Sydney. Prometo compartir cada paso del viaje en mis redes y enviar una postal digital a todos los que colaboren.",
    "storyClosing": "¡Gracias por ser parte de esta aventura!",
    "edit": "Editar",
    "raised": "recaudados",
    "totalRaised": "Total recaudado",
    "goal": "Meta",
    "ofGoal": "de la meta de $3,000 AUD",
    "ofGoalAmount": "de la meta de {{amount}}",
    "completed": "Completado",
    "donors": "Donantes",
    "daysLeft": "Días restantes",
    "donateNow": "Donar ahora",
    "share": "Compartir",
    "spreadWord": "Difunde la palabra",
    "spreadWordSub": "Compartir en redes sociales aumenta 3x las posibilidades de alcanzar la meta.",
    "addPhoneAndInstagramPrompt": "Agrega tu número de teléfono e Instagram en tu perfil para que WhatsApp, Donar y Compartir funcionen en tu campaña.",
    "addPhonePrompt": "Agrega tu número de teléfono en tu perfil para que WhatsApp, Donar y Compartir funcionen en tu campaña.",
    "addInstagramPrompt": "Agrega tu Instagram en tu perfil para que también puedan encontrarte allí.",
    "editProfileDetails": "Editar perfil",
    "viewerWhatsappHint": "Las personas que vean tu campaña podrán enviarte un mensaje por WhatsApp para contratar un servicio o donar dinero.",
    "publicLinkPending": "El enlace público se está generando. Guarda tu campaña para actualizarlo.",
    "publicSpreadWord": "Ayuda a {{name}} a correr la voz",
    "publicSpreadWordSub": "Comparte esta página en redes sociales para ayudar a {{name}} a alcanzar su meta.",
    "createdOn": "Creada el 14 de Octubre, 2023",
    "title": "Mi Campaña",
    "services": "Servicios",
    "whatICanOffer": "Lo que ofrezco",
    "hireNow": "Contratar servicio",
    "hireService": "Contratar un servicio",
    "perHourShort": "/hora",
    "whatsappHireMessage": "Hola {{name}}, estoy interesado en tus servicios de tu campaña: {{url}}",
    "whatsappDonateMessage": "Hola {{name}}, me gustaría donar a tu campaña: {{url}}",
    "whatsappShareMessage": "Mira esta campaña: {{url}}"
  },
  "campaignSetup": {
    "pageTitle": "Turbina - Configuración de campaña",
    "screenTitle": "Configuración de campaña",
    "heading": "¡Cuenta tu historia!",
    "subheading": "Construye tu campaña para que familia, amigos y comunidad se sumen a tu viaje.",
    "helperTitle": "Manténlo simple y auténtico. Comparte tu historia, tu meta y cómo tu comunidad puede apoyarte.",
    "helperTip": "Tip: Haz que tu comunidad sea parte del viaje.",
    "helperBody": "Pide contactos, ideas, sugerencias o cualquier otra ayuda que puedan ofrecer.",
    "yourStoryLabel": "Tu historia",
    "yourStoryPlaceholder": "Cuéntale a la gente quién eres, en qué estás trabajando y por qué esto es importante para ti.",
    "videoGuide": {
      "title": "En tu video, recuerda incluir respuestas a preguntas como:",
      "questions": {
        "whoAreYou": "¿Quién eres?",
        "whatWillYouOffer": "¿Qué ofrecerás a tu comunidad o qué servicios ofreces para generar ingresos?",
        "howWillJourneyHelp": "¿Cómo te ayudará este viaje en el futuro?",
        "whatWantToLearn": "¿Qué quieres aprender o en qué quieres trabajar en Australia?",
        "howCanPeopleHelp": "¿Cómo puede ayudarte tu familia y amigos?!"
      },
      "tipTitle": "Tip: ¡Haz a tu comunidad parte del viaje!",
      "tipBody": "No solo se trata de ofrecer servicios y juntar dinero. Pide a tu comunidad contactos, ideas, sugerencias o cualquier tipo de ayuda con la que creas que ellos puedan aportar."
    },
    "videoLabel": "Tu video de campaña (YouTube)",
    "videoPlaceholder": "https://www.youtube.com/watch?v=...",
    "helpfulResources": "Recursos útiles",
    "addWhatsApp": "Agregar WhatsApp",
    "editWhatsApp": "Editar WhatsApp",
    "addInstagram": "Agregar Instagram",
    "editInstagram": "Editar Instagram",
    "instructionsVideoLabel": "Instrucciones",
    "exampleVideoLabel": "Video de campaña de ejemplo",
    "seeExample": "Ver ejemplo",
    "servicesOffered": "Servicios ofrecidos ({{count}})",
    "servicesHint": "Agrega al menos un servicio antes de publicar tu campaña.",
    "serviceTitlePlaceholder": "Título del servicio",
    "serviceDescriptionPlaceholder": "Descripción",
    "servicePricePlaceholder": "Costo por hora",
    "serviceCurrencyPlaceholder": "AUD",
    "addService": "Agregar servicio",
    "saveService": "Guardar servicio",
    "noServices": "Aún no hay servicios.",
    "noPrice": "Sin costo por hora",
    "perHourShort": "/hora",
    "editService": "Editar",
    "removeService": "Eliminar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saveAndPublish": "Guardar y publicar",
    "show": "Ver",
    "hide": "Ocultar",
    "errors": {
      "loadSetup": "No se pudo cargar la configuración de la campaña.",
      "serviceTitleRequired": "El título del servicio es obligatorio.",
      "invalidPrice": "El costo por hora debe ser un número válido mayor o igual a cero.",
      "saveService": "No se pudo guardar el servicio.",
      "deleteService": "No se pudo eliminar el servicio.",
      "saveCampaign": "No se pudo guardar tu campaña. Inténtalo de nuevo.",
      "openExampleVideo": "No se pudo abrir el video de ejemplo.",
      "storyRequiredBeforeSave": "Agrega tu historia antes de guardar.",
      "addServiceBeforePublish": "Agrega al menos un servicio antes de guardar y publicar tu campaña.",
      "genericError": "Algo salió mal. Por favor intenta de nuevo."
    }
  },
  "community": {
    "pageTitle": "Turbina - Comunidad",
    "title": "Comunidad Turbina",
    "subtitle": "Este es tu espacio para conectar con otros Turbinos que también están viajando a Australia pronto.",
    "pulseTitle": "Publicaciones de la comunidad",
    "liveUpdates": "Actualizaciones en vivo",
    "upcomingMeetup": "Próximos encuentros",
    "joinMeetup": "Unirme",
    "cancelMeetup": "Cancelar",
    "joinedMeetup": "Inscrito ✓",
    "openMeetupLink": "Abrir enlace",
    "addToCalendarMeetup": "Añadir al calendario",
    "addToCalendarErrorTitle": "Calendario",
    "addToCalendarError": "No se pudo añadir este encuentro a tu calendario.",
    "addToCalendarPermissionDenied": "Permite acceso al calendario para añadir este encuentro.",
    "noUpcomingMeetups": "No hay encuentros próximos programados.",
    "meetupNotOpenYet": "Aún no abierto",
    "pastMeetups": "Encuentros pasados",
    "noPastMeetups": "Aún no hay encuentros pasados.",
    "meetupAttendeeCount": "{{count}} participantes",
    "meetupsLoadError": "No se pudieron cargar los encuentros ahora.",
    "shareStory": "+ Compartir mi historia",
    "turbinosInAustralia": "Turbinos viajando a Australia",
    "raisedForCampaigns": "Ahorrado hasta ahora",
    "approvedVisas": "Visas aprobadas este mes",
    "explore": "Explorar",
    "successStories": "Historias de Éxito",
    "activeCampaigns": "Campañas Activas",
    "tipsAndAdvice": "Tips y Consejos",
    "meetups": "Encuentros",
    "needVisaHelp": "¿Necesitas ayuda con tu visa?",
    "visaHelpSub": "Nuestra comunidad tiene guías actualizadas para la Working Holiday 462.",
    "viewGuide": "Ver Guía",
    "trending": "Campañas Activas",
    "whoToFollow": "A quién seguir",
    "newestCohortMembers": "Miembros de la generación",
    "showMembers": "Mostrar miembros",
    "hideMembers": "Ocultar miembros",
    "noCohortMembers": "Aún no hay miembros en esta generación.",
    "membersLoadError": "No se pudieron cargar los miembros de la generación 1 en este momento.",
    "showCampaigns": "Mostrar campañas",
    "hideCampaigns": "Ocultar campañas",
    "noTrendingCampaigns": "Aún no hay campañas en tendencia.",
    "campaignsLoadError": "No se pudieron cargar las campañas en este momento.",
    "campaignUnpublished": "No publicada",
    "memberCampaignNotSetUp": "La campaña de este miembro aún no ha sido configurada.",
    "memberCampaignNotSetUpTitle": "Campaña no disponible",
    "seeMore": "Ver más sugerencias",
    "copyright": "Turbina © 2026 · Privacidad · Términos · Ayuda",
    "view": "Ver",
    "wemoveExperience": "WeMove Experience",
    "joinWhatsApp": "Unirse al grupo de WhatsApp"
  },
  "feed": {
    "composePlaceholder": "¿Cómo va tu proceso de ahorro?"
  },
  "settings": {
    "pageTitle": "Ajustes",
    "language": "Idioma",
    "languageDescription": "Elige tu idioma preferido",
    "en": "English",
    "es": "Español",
    "pt": "Português",
    "theme": "Tema",
    "themeLight": "Claro",
    "themeDark": "Oscuro",
    "themeSystem": "Sistema",
    "signOut": "Cerrar sesión",
    "legal": "Legal",
    "termsOfUse": "Términos de Uso",
    "privacyPolicy": "Política de Privacidad"
  },
  "profile": {
    "pageTitle": "Editar perfil",
    "profileStudioBadge": "Estudio de perfil",
    "profileStudioDescription": "Mantén tu perfil completo para que tus mentores y oportunidades entiendan tus objetivos al instante.",
    "profileCompletion": "Progreso del perfil",
    "profileMetricCompletion": "Completado",
    "profileMetricContact": "Contacto",
    "profileStatusAvailable": "Disponible",
    "profileStatusAddDetails": "Agregar datos",
    "personalInfo": "Información personal",
    "personalInfoSubtitle": "Identidad y datos de contacto",
    "yourJourney": "Tu viaje",
    "journeySubtitle": "Objetivos, tiempos y contexto de ubicación",
    "background": "Antecedentes",
    "name": "Nombre",
    "surname": "Apellido",
    "phone": "Teléfono",
    "instagram": "Instagram",
    "goal": "Objetivo",
    "destination": "Destino",
    "timeline": "Tiempo",
    "ageRange": "Rango de edad",
    "originCity": "Ciudad de origen",
    "originCountry": "País de origen",
    "savingsStatus": "Finanzas",
    "currentSituation": "Situación",
    "edit": "Editar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "saveSuccess": "¡Guardado!",
    "saveError": "No se pudo guardar. Intenta de nuevo.",
    "invalidPhone": "Ingresa un teléfono válido en formato internacional (por ejemplo +56999999999).",
    "invalidInstagramHandle": "Ingresa un usuario de Instagram válido.",
    "cityPlaceholder": "Ciudad de origen",
    "phonePlaceholder": "+56999999999",
    "instagramPlaceholder": "@tuusuario",
    "changePassword": "Cambiar contraseña",
    "changePasswordSubtitle": "Refuerza la seguridad de tu cuenta",
    "currentPasswordPlaceholder": "Contraseña actual",
    "newPasswordPlaceholder": "Nueva contraseña",
    "confirmPasswordPlaceholder": "Confirmar nueva contraseña",
    "passwordMismatch": "Las contraseñas no coinciden.",
    "passwordChanged": "¡Contraseña cambiada!"
  },
  "terms": {
    "pageTitle": "Términos de Uso - Turbina",
    "pageDescription": "Lee los Términos de Uso del piloto de Turbina, incluyendo alcance del servicio, responsabilidades del usuario, normas comunitarias y compromisos de privacidad.",
    "heading": "Términos de Uso",
    "intro": "Estos términos aplican a la participación en el programa piloto de Turbina y al uso de la plataforma.",
    "importantNotice": "Importante: Turbina no es un agente migratorio registrado. Turbina solo ofrece planificación y apoyo comunitario, y no brinda asesoría migratoria regulada.",
    "section1Title": "Descargo de Responsabilidad del Servicio",
    "section1Body": "Turbina es una plataforma de planificación, orientación, acompañamiento y comunidad para personas que buscan experiencias internacionales.\n\nTurbina no garantiza aprobación de visas, admisión en programas educativos, resultados laborales ni éxito migratorio.\n\nTurbina no es una agencia de migración, no brinda asesoría legal ni migratoria formal y no representa gobiernos, universidades, autoridades migratorias ni instituciones oficiales.",
    "section2Title": "Responsabilidad del Usuario",
    "section2Body": "Las decisiones finales de viaje y migración son responsabilidad del usuario.\n\nLos usuarios deben verificar de forma independiente los requisitos oficiales en fuentes oficiales, incluyendo el Departamento del Interior de Australia.\n\nLos usuarios siguen siendo responsables de cumplir requisitos de visa, financieros, de salud, académicos y legales.",
    "section3Title": "Conducta Comunitaria",
    "section3Body": "Los participantes deben cumplir estándares de convivencia respetuosos.\n\nSe prohíben el acoso, la discriminación, el spam, la promoción engañosa, la información falsa, las solicitudes fraudulentas de financiamiento, el uso indebido de contactos comunitarios y la solicitud no autorizada.\n\nTurbina puede suspender o eliminar participantes por conducta inapropiada.",
    "section4Title": "Recaudación y Apoyo Financiero",
    "section4Body": "Turbina ofrece herramientas de campaña y visibilidad, pero no garantiza contribuciones.\n\nTurbina no verifica todas las afirmaciones de campaña, no controla cómo se usan los fondos y no actúa como intermediario financiero en el piloto.\n\nPara el piloto, los usuarios deben recibir apoyo a través de sus propias cuentas o proveedores externos.",
    "section5Title": "Privacidad y Consentimiento de Datos",
    "section5Body": "Al participar, los usuarios consienten que Turbina recopile y procese la información necesaria para ofrecer el programa, incluyendo datos de perfil, respuestas de postulación, metas de ahorro, datos de planificación y participación comunitaria.\n\nEl uso de historias, videos o testimonios para marketing requiere consentimiento separado.",
    "section6Title": "Propiedad de Contenido y Derechos de la Plataforma",
    "section6Body": "Los usuarios conservan la propiedad del contenido que suben, incluyendo videos de postulación, metas escritas, contenido de campaña y actualizaciones de progreso.\n\nLos usuarios otorgan a Turbina una licencia limitada para mostrar ese contenido dentro de la plataforma.\n\nLos usuarios son responsables de que el contenido sea veraz y legal, y Turbina puede eliminar contenido inapropiado.",
    "section7Title": "Condiciones de Participación del Piloto",
    "section7Body": "Turbina Primera Generación es un programa piloto (beta). Las funcionalidades, sesiones y el acceso pueden cambiar mientras el producto evoluciona.\n\nSe espera que los participantes entreguen retroalimentación y Turbina puede iterar rápidamente durante el piloto.",
    "contactPrompt": "¿Tienes dudas sobre estos términos? Escríbenos a:",
    "contactEmail": "hola@turbinago.com"
  },
  "savingsAccordion": {
    "savingsBreakdown": "Desglose de Metas",
    "sliderHelper": "Usa los controles deslizantes para ajustar el costo de tu viaje.",
    "percentFunded": "% financiado",
    "saveChanges": "Guardar Cambios",
    "saved": "Guardado"
  },
  "youtubePlayer": {
    "loadingVideo": "Cargando video..."
  },
  "hq": {
    "pageTitle": "Panel — Turbina HQ",
    "dashboardTitle": "Panel",
    "dashboardSubtitle": "Solicitudes y vista general de la generación de Turbina",
    "totalUsers": "Total de Usuarios",
    "maxUsers": "Max Usuarios",
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "waitlist": "Lista de espera",
    "pendingWaitlist": "Lista de espera pendiente",
    "inCohort": "En el Generación 1",
    "failedLoadStats": "Error al cargar estadísticas",
    "loginPageTitle": "Inicio de sesión — Turbina HQ",
    "loginTitle": "HQ",
    "emailPlaceholder": "Correo electrónico",
    "passwordPlaceholder": "Contraseña",
    "mfaInstruction": "Ingresa el código de tu aplicación de autenticación",
    "mfaCodePlaceholder": "000000",
    "signIn": "Iniciar sesión",
    "verify": "Verificar",
    "back": "Atrás",
    "accessDenied": "Acceso denegado",
    "signInFailed": "Error al iniciar sesión",
    "invalidCode": "Código inválido",
    "applicationsPageTitle": "Solicitudes — Turbina HQ",
    "applicationsTitle": "Solicitudes",
    "applicationsSubtitle": "Revisar y gestionar las solicitudes de candidatos",
    "applicationsPageRange": "Mostrando {{from}}–{{to}} de {{total}}",
    "searchPlaceholder": "Buscar candidatos…",
    "searchButton": "Buscar",
    "goalLabel": "Objetivo",
    "filterAll": "Todos",
    "filterPending": "Pendiente",
    "filterApproved": "Aprobado",
    "filterRejected": "Rechazado",
    "actionUndo": "Deshacer",
    "actionAccept": "Aceptar",
    "actionReject": "Rechazar",
    "watchVideo": "Ver Video de Solicitud",
    "applicationDateLabel": "Fecha de postulación",
    "submissionTypeVideo": "Video",
    "submissionTypeWritten": "Escrita",
    "submissionTypeUnknown": "Sin tipo",
    "writtenAnswers": "Respuestas escritas",
    "noApplicantsMatch": "Ningún solicitante coincide con tu búsqueda.",
    "noApplications": "No hay solicitudes para mostrar.",
    "confirmEnroll": "¿Inscribir a {{name}} en el cohorte activo?",
    "confirmReject": "¿Rechazar la solicitud de {{name}}?",
    "confirmReset": "¿Restablecer el estado de {{name}} a pendiente?",
    "failedUpdateStatus": "Error al actualizar el estado. Por favor, inténtalo de nuevo.",
    "failedResetStatus": "Error al restablecer el estado. Por favor, inténtalo de nuevo.",
    "failedLoadApplications": "Error al cargar solicitudes",
    "cohortPageTitle": "Cohorte — Turbina HQ",
    "cohortTitle": "Cohorte",
    "cohortSubtitle": "Miembros del cohorte activo y capacidad",
    "capacityLabel": "Capacidad",
    "removeButton": "Eliminar",
    "noActiveCohort": "Sin Cohorte Activo",
    "membersCount": "miembros",
    "membersSection": "Miembros",
    "noCohortMembers": "Aún no hay miembros en el cohorte.",
    "confirmRemoveMember": "¿Eliminar a {{name}} del cohorte?",
    "failedRemoveMember": "Error al eliminar miembro. Por favor, inténtalo de nuevo.",
    "failedLoadCohort": "Error al cargar el cohorte",
    "waitlistPageTitle": "Lista de espera — Turbina HQ",
    "waitlistTitle": "Lista de espera",
    "waitlistSubtitleSingular": "{{count}} persona en espera",
    "waitlistSubtitlePlural": "{{count}} personas en espera",
    "waitlistPageRange": "Mostrando {{from}}–{{to}} de {{total}}",
    "waitlistEmpty": "La lista de espera está vacía.",
    "failedLoadWaitlist": "Error al cargar la lista de espera",
    "paginationPrev": "Anterior",
    "paginationNext": "Siguiente",
    "paginationPageOf": "Página {{page}} de {{totalPages}}",
    "navHome": "Inicio",
    "navApplications": "Solicitudes",
    "navCohorts": "Cohortes",
    "navWaitlist": "Lista de espera",
    "navMeetups": "Encuentros",
    "meetupPageTitle": "Encuentros — Turbina HQ",
    "meetupTitle": "Encuentros",
    "meetupSubtitle": "Programar y gestionar encuentros de la comunidad",
    "createMeetup": "Crear encuentro",
    "saveMeetup": "Guardar",
    "cancel": "Cancelar",
    "meetupTitleLabel": "Título",
    "meetupDateTimeLabel": "Fecha y hora",
    "meetupLinkLabel": "Enlace de Google Meet",
    "meetupAttendeesLabel": "Participantes",
    "noMeetupAttendees": "Aún no hay participantes.",
    "confirmDeleteMeetup": "¿Eliminar encuentro \"{{title}}\"?",
    "failedLoadMeetups": "Error al cargar los encuentros",
    "failedCreateMeetup": "Error al crear el encuentro. Inténtalo de nuevo.",
    "failedEditMeetup": "Error al guardar los cambios. Inténtalo de nuevo.",
    "failedDeleteMeetup": "Error al eliminar el encuentro. Inténtalo de nuevo.",
    "noMeetups": "Aún no hay encuentros programados.",
    "meetupPast": "pasado",
    "meetupPastSection": "Encuentros pasados",
    "quickActions": "Acciones Rápidas",
    "reviewApplications": "Revisar Solicitudes",
    "pendingReview_one": "{{count}} pendiente de revisión",
    "pendingReview_other": "{{count}} pendientes de revisión",
    "manageCohort": "Gestionar Cohorte",
    "activeMembers_one": "{{count}} miembro activo",
    "activeMembers_other": "{{count}} miembros activos"
  },
  "goal": {
    "flightLabel": "Estimado del Vuelo",
    "flightHint": "Económico ($800) — Premium ($3,000+)",
    "expensesLabel": "Gastos Iniciales (1er Mes)",
    "expensesHint": "Incluye hostel/depósito, comida, transporte y SIM.",
    "visaLabel": "Visa",
    "visaHint": "Tarifas de solicitud de visa y costos de procesamiento.",
    "studyLabel": "Estudios",
    "studyHint": "Costos de curso, materiales e inscripción.",
    "travelInsuranceLabel": "Seguro de viaje",
    "travelInsuranceHint": "Recomendado: cobertura integral durante todo el viaje.",
    "othersLabel": "Otros",
    "othersHint": "Cualquier gasto personal adicional no cubierto arriba.",
    "goalSummary": "Resumen de tu Meta",
    "totalGoal": "Meta Total",
    "targetDeparture": "SALIDA OBJETIVO",
    "targetDepartureHint": "Edita para definir tu fecha de viaje",
    "costCalculator": "Calculadora de costos"
  },
  "privacy": {
    "pageTitle": "Privacidad y Datos — Turbina",
    "pageDescription": "Conoce de forma clara qué datos recopila Turbina, por qué los usamos, cómo los protegemos y qué opciones tienes para gestionar tu información en esta etapa MVP.",
    "heading": "Privacidad y Datos",
    "section1Title": "Resumen Rápido",
    "section1Body": "Turbina está en etapa MVP. Recopilamos solo la información necesaria para crear tu plan y acompañar tu postulación.",
    "section2Title": "Cómo Funciona el Inicio de Sesión",
    "section2Body": "Puedes iniciar sesión con Google o con email.\n\nSi usas Google (u otro proveedor de autenticación), recibimos datos básicos de la cuenta y nunca vemos la contraseña de ese proveedor.\n\nSi usas email y contraseña, la contraseña está protegida y nuestro equipo no puede verla en texto plano.",
    "section3Title": "Qué Recopilamos",
    "section3Body": "Datos básicos de cuenta (nombre y email).\n\nTus respuestas de onboarding y postulación.\n\nInformación no sensible de planificación, como destino, cronograma y avance de ahorro.\n\nDatos básicos de uso de la app para mejorar su funcionamiento.",
    "section4Title": "Qué No Recopilamos",
    "section4Body": "No recopilamos datos de tarjetas de pago, credenciales bancarias, ubicación GPS, contactos ni datos biométricos.",
    "section5Title": "Cómo Usamos Estos Datos",
    "section5Body": "Usamos tus datos para personalizar tu hoja de ruta, mostrar tu progreso y comunicar actualizaciones importantes sobre tu cuenta o postulación.",
    "section6Title": "Sin Venta ni Compartir con Terceros",
    "section6Body": "En esta etapa, no vendemos tus datos personales.\n\nTampoco compartimos tus datos personales con agencias de viaje, reclutadores ni terceros similares.",
    "section7Title": "Cómo Protegemos los Datos",
    "section7Body": "Usamos prácticas de seguridad estándar y limitamos el acceso a miembros autorizados del equipo de Turbina.",
    "section8Title": "Tus Opciones",
    "section8Body": "Puedes actualizar la información de tu perfil dentro de la app.\n\nPuedes solicitar la eliminación de tu cuenta y tus datos escribiéndonos.",
    "section9Title": "Actualizaciones de la Política",
    "section9Body": "Si esta política cambia, actualizaremos esta página.",
    "section10Title": "Contacto",
    "section10Body": "¿Tienes preguntas sobre privacidad o datos? Escríbenos a: hola@turbinago.com",
    "contactPrompt": "¿Tienes preguntas o comentarios? Nos encantará escucharte.",
    "contactEmail": "hola@turbinago.com"
  },
  "faq": {
    "pageTitle": "Ayuda y FAQ — Turbina",
    "pageDescription": "Encuentra respuestas claras sobre cómo funciona Turbina, para quién está pensada, costos, comunidad, postulación y cómo protegemos tu privacidad.",
    "heading": "Preguntas frecuentes",
    "intro": "Todo lo que necesitas saber para planificar tu experiencia internacional con Turbina.",
    "section1Question": "¿Qué es Turbina?",
    "section1Answer": "Turbina es una plataforma que ayuda a jóvenes a convertir el sueño de irse al exterior en un plan concreto. Combinamos una hoja de ruta personalizada, herramientas de ahorro y apoyo comunitario para que cada paso sea alcanzable.",
    "section2Question": "¿Para quién es Turbina?",
    "section2Answer": "Turbina está pensada para jóvenes, especialmente en América Latina, que buscan una experiencia internacional como Working Holiday, estudios de idioma o estudios en el extranjero.",
    "section3Question": "¿Cómo funciona la hoja de ruta personalizada?",
    "section3Answer": "Después del onboarding, usamos tu destino, cronograma, objetivos y situación financiera actual para ordenar tus próximos pasos: tareas de preparación, costos estimados y prioridades.",
    "section4Question": "¿Cómo funcionan los ahorros y la recaudación?",
    "section4Answer": "Puedes definir tu meta por categoría (vuelo, visa, gastos iniciales y más), seguir tu progreso visualmente y crear una campaña para que familia y amigos apoyen tu viaje.",
    "section5Question": "¿Turbina es gratis?",
    "section5Answer": "Sí. Turbina es gratuita para viajeros. Nuestra misión es hacer más accesibles las oportunidades internacionales.",
    "section6Question": "¿Cómo me ayuda la comunidad?",
    "section6Answer": "Turbina te conecta con personas que van a destinos o fechas similares, para compartir consejos, motivación y apoyo práctico antes de viajar.",
    "section7Question": "¿Qué datos recopila Turbina?",
    "section7Answer": "Recopilamos solo lo necesario para ofrecer tu experiencia: datos de cuenta, información de onboarding, datos de postulación, progreso de ahorro y analíticas de uso anonimizadas.",
    "section8Question": "¿Turbina vende mis datos personales?",
    "section8Answer": "No. Los datos personales individuales no se venden. Algunas tendencias de onboarding pueden usarse solo de forma agregada y anonimizada para entender patrones de movilidad.",
    "section9Question": "¿Turbina puede apoyar destinos fuera de Australia?",
    "section9Answer": "Sí. Aunque hoy la orientación más fuerte está en rutas específicas, Turbina está diseñada para movilidad internacional más amplia y sigue expandiendo su soporte.",
    "section10Question": "¿Cómo puedo recibir ayuda?",
    "section10Answer": "Si tienes dudas sobre la plataforma, tu cuenta o privacidad, escríbenos a hola@turbinago.com.",
    "contactPrompt": "Si todavía tienes preguntas o quieres compartir feedback, estamos para ayudarte.",
    "contactEmail": "hola@turbinago.com"
  },
  "footer": {
    "tagline": "Tu pista de despegue hacia el mundo",
    "madeWith": "Hecho con amor para exploradores latinoamericanos",
    "about": "Nosotros",
    "terms": "Términos",
    "privacy": "Privacidad",
    "youtube": "YouTube",
    "instagram": "Instagram",
    "status_onTime": "A TIEMPO",
    "status_boarding": "EMBARCANDO",
    "status_departed": "DESPEGADO"
  },
  "notFound": {
    "pageTitle": "Página no encontrada — Turbina",
    "heading": "404",
    "title": "Página no encontrada",
    "body": "La página que buscas no existe o ha sido movida.",
    "cta": "Volver al inicio"
  },
  "communityFeed": {
    "composePlaceholder": "Comparte algo con tu generación...",
    "searchPlaceholder": "Buscar publicaciones...",
    "searchButton": "Buscar",
    "clearSearch": "Limpiar",
    "orderBy": "Ordenar por",
    "scanningFrequencies": "ESCANEANDO FRECUENCIAS",
    "clearanceRequired": "ACCESO REQUERIDO",
    "newPost": "NUEVA PUBLICACIÓN",
    "createPost": "Crear Publicación",
    "loadingSignal": "CARGANDO SEÑAL...",
    "postButton": "Publicar",
    "deletePost": "Eliminar publicación",
    "deleteComment": "Eliminar comentario",
    "confirmDelete": "¿Estás seguro?",
    "commentsTitle": "Comentarios",
    "echoChannel": "Comentarios",
    "commentPlaceholder": "Añade un comentario...",
    "noComments": "Aún no hay comentarios.",
    "noPosts": "Aún no hay publicaciones. ¡Sé el primero!",
    "noSearchResults": "No hay publicaciones que coincidan con tu búsqueda.",
    "accessBlockedTitle": "La comunidad se habilita cuando tu generación esté activa",
    "accessBlockedBody": "Podrás ver y publicar cuando tu postulación a esta generación esté aceptada",
    "loadMore": "Cargar más",
    "charLimit": "{{count}} caracteres restantes",
    "postError": "Error al publicar. Inténtalo de nuevo.",
    "commentError": "Error al comentar. Inténtalo de nuevo.",
    "send": "ENVIAR",
    "transmitting": "TX...",
    "sortNew": "Nuevo",
    "sortTop": "Top",
    "comments": "Comentarios",
    "share": "Compartir",
    "endOfFeed": "Fin de la señal",
    "pinned": "Fijado"
  },
  "unsubscribe": {
    "pageTitle": "Darse de baja — Turbina",
    "heading": "Darse de baja",
    "loading": "Procesando...",
    "successMessage": "Has sido dado de baja de los correos de Turbina. No recibirás más mensajes de nuestra parte.",
    "errorMessage": "El enlace no es válido o ha expirado. Si necesitas ayuda, escríbenos a hola@turbinago.com.",
    "backToHome": "Volver al inicio"
  },
  "tutorial": {
    "title": "¡Bienvenido a bordo!",
    "skip": "Saltar recorrido",
    "next": "Siguiente",
    "back": "Atrás",
    "done": "¡Listo!",
    "step1Title": "Tu Ruta de Vuelo",
    "step1Message": "Esta es tu ruta de vuelo. ¡Mira cómo tu avión se acerca a tu destino mientras ahorras!",
    "step2Title": "Define tu Presupuesto",
    "step2Message": "Desglosa tu meta en categorías. Arrastra los controles para estimar costos.",
    "step3Title": "Tu Fecha de Salida",
    "step3Message": "Toca para indicar cuándo quieres salir. Esto nos ayuda a calcular tu progreso.",
    "step4Title": "Tus Ahorros",
    "step4Message": "Toca para registrar cuánto has ahorrado. ¡Mira crecer tu progreso!"
  },
  "campaignSetupTutorial": {
    "step1Title": "Recursos Útiles",
    "step1Message": "Mira estos videos cortos antes de comenzar — te guiarán sobre qué incluir en tu campaña.",
    "step2Title": "Tu Historia",
    "step2Message": "Cuenta al mundo quién eres y por qué este viaje es importante para ti. Esto es lo primero que verán tus seguidores.",
    "step3Title": "Ofrece Servicios",
    "step3Message": "Agrega al menos un servicio que puedas ofrecer a tus seguidores, como una postal, videollamada o actualización de viaje."
  },
  "campaignTutorial": {
    "step1Title": "Edita Tu Historia",
    "step1Message": "Toca aquí para editar la historia de tu campaña, vídeo y personalizar tu página.",
    "step2Title": "Total Recaudado",
    "step2Message": "Este es tu total recaudado — sigue tu progreso hacia tu meta de viaje.",
    "step3Title": "Difunde la Noticia",
    "step3Message": "Comparte tu campaña por WhatsApp, Instagram o copia el enlace para llegar a más personas."
  },
  "communityTutorial": {
    "step1Title": "Feed de la Comunidad",
    "step1Message": "Este es el feed de la comunidad — descubre historias de viaje, consejos y novedades de otros Turbiners.",
    "step2Title": "Próximos Meetups",
    "step2Message": "Únete a meetups de viaje y conecta con otros viajeros de tu cohorte."
  }
}